/**
 * Timesheet hours are stored as decimals with two digits (1:20 → 1.33). Every whole minute survives
 * that round trip, so entry and display can work in hours and minutes while the API keeps decimals.
 */

type HoursValue = number | string | null | undefined;

export const MINUTES_PER_HOUR = 60;

export const hoursToMinutes = (hours: HoursValue): number => Math.round((Number(hours) || 0) * MINUTES_PER_HOUR);

export const minutesToHours = (minutes: number): number => Math.round((minutes / MINUTES_PER_HOUR) * 100) / 100;

/** Sum minute by minute, so 3 × 0:20 is 1:00 and not the 0:59 the rounded decimals would give. */
export const sumHours = (values: HoursValue[]): number =>
  values.reduce<number>((sum, value) => sum + hoursToMinutes(value), 0) / MINUTES_PER_HOUR;

/** "8:00", "0:45", "160:30" */
export const formatDuration = (hours: HoursValue): string => {
  const total = hoursToMinutes(hours);
  const h = Math.floor(total / MINUTES_PER_HOUR);
  const m = total % MINUTES_PER_HOUR;
  return `${h}:${String(m).padStart(2, '0')}`;
};

/** On call that day. Entries saved before the flag existed only tell it by their on-call hours. */
export const isOnCall = (entry: { onCall?: boolean | null; onCallHours?: HoursValue }): boolean =>
  Boolean(entry.onCall) || (Number(entry.onCallHours) || 0) > 0;
